import { render, staticRenderFns } from "./CandidateSearch.vue?vue&type=template&id=0b574b07&scoped=true&"
import script from "./CandidateSearch.vue?vue&type=script&lang=js&"
export * from "./CandidateSearch.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSearch.vue?vue&type=style&index=0&id=0b574b07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b574b07",
  null
  
)

export default component.exports